import React from "react";
export function Footer() {
  return <footer className="bg-navy-950 px-4 pb-32 pt-12 text-white/60 sm:px-6" data-id="element-184" data-mp="19ivlq3plplne">
      <div className="mx-auto max-w-3xl border-t border-white/10 pt-10 text-center" data-id="element-185" data-mp="206j5zpmfcnhk">
        <h2 className="font-display text-sm font-extrabold uppercase tracking-wide text-white/85" data-id="element-186" data-mp="2f53fjo5x71jx">
          Professional educational disclaimer
        </h2>
        <div className="mt-4 space-y-3 text-xs leading-relaxed" data-id="element-187" data-mp="2a3w6zmvydyc7">
          <p data-id="element-188" data-mp="1mgo050ivmh82">
            The Mandibular Complete Denture Blueprint™ is intended for educational and professional reference purposes
            only. The information provided does not replace comprehensive clinical assessment, individualized treatment
            planning, professional judgment, specialist consultation, or applicable regulations.
          </p>
          <p data-id="element-189" data-mp="13p4wcrh12z4z">
            No specific clinical outcome, degree of retention, patient satisfaction, or treatment success is guaranteed.
            Clinical decisions remain the responsibility of the treating licensed professional.
          </p>
        </div>
        <div className="mt-8 space-y-2 text-xs" data-id="element-190" data-mp="1efzlcubq08dn">
          <p className="font-semibold text-white/80" data-id="element-191" data-mp="1iivxc26r968m">© 2026 Mandibular Complete Denture Blueprint™ · Dr. Valeria Montes</p>
          <p data-id="element-192" data-mp="1naxikdlwi7as">All rights reserved. Unauthorized reproduction, distribution, or resale of this digital material is prohibited.</p>
          <p data-id="element-193" data-mp="1sblad1hyes62">
            Mandibular Complete Denture Blueprint™ is an educational resource and is not affiliated with or endorsed by
            any dental professional organization.
          </p>
        </div>
      </div>
    </footer>;
}